import api from '../../services/api';
import { OPERATOR_REQUEST_CONFIG, warehousePath } from '../operator/operatorApi';

/*
 * Kits on the floor: putting assembled kits together from their components,
 * and taking them apart. Free work with no tasks. The kardex records each one
 * as adjustments with `kit:<id>` as reference.
 */

/**
 * The kits put together here, the ones that can be made now first, then by
 * SKU. `code` narrows to a kit's codes (barcode, SKU, a pack's barcode).
 *
 * @param {number|string} warehouseId
 * @param {{code?: string, page?: number}} [params]
 */
export const getKitsRequest = (warehouseId, { code = '', page = 1 } = {}) =>
  api.get(warehousePath(warehouseId, 'kits/'), {
    ...OPERATOR_REQUEST_CONFIG,
    params: { page, ...(code ? { code } : {}) },
  });

/** One kit: its components with what is free, and how many can be made. 404 when it is not one of the station's. */
export const getKitRequest = (warehouseId, kitId) =>
  api.get(warehousePath(warehouseId, `kits/${kitId}/`), OPERATOR_REQUEST_CONFIG);

/**
 * How to put `quantity` kits together now, or take them apart: where each
 * component comes from (or the kits), and where to leave the result.
 *
 * @param {number|string} warehouseId
 * @param {number} kitId
 * @param {{mode: 'assemble'|'disassemble', quantity: number}} params
 */
export const getKitPlanRequest = (warehouseId, kitId, { mode, quantity }) =>
  api.get(warehousePath(warehouseId, `kits/${kitId}/plan/`), { ...OPERATOR_REQUEST_CONFIG, params: { mode, quantity } });

/**
 * Puts kits together: `{quantity, sources[{product_id, slot_code, lot, quantity}], to_slot_code, lot?,
 * expiry_date?, idempotency_key}`. 201, or 200 `replayed`; 412 when the stock changed since the plan.
 */
export const assembleKitRequest = (warehouseId, kitId, body) =>
  api.post(warehousePath(warehouseId, `kits/${kitId}/assemble/`), body, OPERATOR_REQUEST_CONFIG);

/** Takes kits apart: `{quantity, from_slot_code, lot, to_slot_code, idempotency_key}`. Same answers. */
export const disassembleKitRequest = (warehouseId, kitId, body) =>
  api.post(warehousePath(warehouseId, `kits/${kitId}/disassemble/`), body, OPERATOR_REQUEST_CONFIG);
